import getUserConfiguration from '../actions/getUserConfiguration';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getIdleSessionTimeout } from '../utils/getIdleSessionTimeout';

export function isSharedABTEnabled(): boolean {
    return !!(
        isGlobalFeatureEnabled('auth-sharedActivityBasedTimeout') &&
        (getUserConfiguration().PolicySettings?.IsSharedActivityBasedTimeoutEnabled ||
            !!getIdleSessionTimeout())
    );
}
